import { render, staticRenderFns } from "./BtnXBig.vue?vue&type=template&id=6861f5fc&"
import script from "./BtnXBig.vue?vue&type=script&lang=js&"
export * from "./BtnXBig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports